import { useState, useEffect } from "react";
import { toast } from "../utils/toast";

export default function ResumeModal({ onClose, onSubmit, initialResume }) {
  const [title, setTitle] = useState("");
  const [file, setFile] = useState(null);

  useEffect(() => {
    if (initialResume) setTitle(initialResume.title || "");
  }, [initialResume]);

  const handleSubmit = () => {
    if (!title.trim()) { toast("Title is required"); return; }
    if (!initialResume && !file) { toast("A PDF file is required"); return; }
    onSubmit({ title, file });
    onClose();
  };

  return (
    <div className="modal-overlay">
      <div className="modal-content doc-modal">
        <h2>{initialResume ? "Edit Resume" : "Add Resume"}</h2>

        <div className="field">
          <label>Title</label>
          <input
            className="input-sm"
            value={title}
            onChange={(e) => setTitle(e.target.value)}
            placeholder="e.g. Software Engineer Resume"
          />
        </div>

        <div className="field">
          <label>{initialResume ? "Replace PDF" : "PDF"}</label>
          <input
            type="file"
            accept="application/pdf"
            onChange={(e) => setFile(e.target.files[0])}
          />
          {initialResume && <span className="field-hint">Leave blank to keep existing file</span>}
        </div>

        <div className="modal-buttons">
          <button onClick={handleSubmit}>{initialResume ? "Save Changes" : "Add Resume"}</button>
          <button className="secondary" onClick={onClose}>Cancel</button>
        </div>
      </div>
    </div>
  );
}
